import { Component,  OnInit } from '@angular/core';
import { SettingsService } from '../../Services';

@Component({
    selector: 'mijn-voertuigen',
    templateUrl: 'mijn_voertuigen.component.html',
    styleUrls: ['mijn_voertuigen.component.css'],
    standalone: false
})

export class MijnVoertuigenComponent implements OnInit {
    pageSettings: any;

    constructor(public setting: SettingsService) {}
    ngOnInit() {
        let viewType: any;
        if (this.setting.getSetting('show_overview_layout') === 'Foto' ) {
            viewType = 'grid';
        }
        if (this.setting.getSetting('show_overview_layout') === 'Lijst' ) {
            viewType = 'list';
        }
        this.pageSettings = ({
            // View options
            Title: 'Mijn voertuigen', // The main title of the page.
            HtmlTitle: 'Expertteam - Mijn Voertuigen', // The name of the tab in the browser.
            DefaultViewType: viewType, // This can be set to list or grid.
            MaxResultsSettingName: 'valuations_per_page_mijn_voertuigen',

            AllowBidding: false, // This will enable the option to bid when navigating to detail page
            AllowNavigationOnClick: true, // This will allow the user to navigate to the detail page when row is clicked.

            EnableGridView: true, // The 'gallery' view.
            EnableListView: true, // Default table view.

            EnableOrdering: false,
            EnableFiltering: true, // Enable or disable the filering field, if disabled the default filter will be used.
            EnableSearching: true, // Enable or disable the searching field.
            EnableAmoutOfResults: true,
            EnableItemClicked: true,

            RefreshInterval: 0, // Time in MS when to fetch new data, 0 for disabled.

            // These fields are used to set the search type when searching.
            SearchFields: [{ DisplayName: 'Taxatienummer', RequestFilter: 'assigned' },
            { DisplayName: 'Biedtermijn', RequestFilter: 'assigned' },
            { DisplayName: 'Voertuig', RequestFilter: 'assigned' },
            { DisplayName: 'Kenteken', RequestFilter: 'assigned' },
            { DisplayName: 'Bouwjaar', RequestFilter: 'assigned' },
            { DisplayName: 'Carrosserie', RequestFilter: 'assigned' }],

            // These fields are used to fill the table with some data.
            TableFields: [{ApiField: 'id', DisplayName: 'Taxnr', EnableOrdering: true, orderField: 'id'},
            {ApiField: 'VehicleLicense', DisplayName: 'Kenteken', EnableOrdering: false, orderField: ''},
            {ApiField: 'VehicleMakeType', DisplayName: 'Voertuig', EnableOrdering: true, orderField: 'Vehicle.make'},
            {ApiField: 'VehicleYear', DisplayName: 'Jaar',  EnableOrdering: true, orderField: 'Vehicle.year'},
            {ApiField: 'VehicleDeliveryDate', DisplayName: 'Leverdatum', EnableOrdering: true, orderField: 'dateDelivery'},
            {ApiField: 'BoughtOn', DisplayName: 'Gekocht op', EnableOrdering: false, orderField: ''},
            {ApiField: 'BoughtFor', DisplayName: 'Gekocht voor', EnableOrdering: false, orderField: ''},
            {ApiField: 'BoughtVia', DisplayName: 'Gekocht onder', EnableOrdering: false, orderField: ''}],

            // These fields are used to set the filter types.
            FilteringFields: [{ DisplayName: 'Te verwachten', RequestFilter: ['assignedNotDelivered'] },
            { DisplayName: 'Gelost afgelopen 5 dagen', RequestFilter: ['assignedRecentlyDelivered'] },
            { DisplayName: 'Toegewezen', RequestFilter: ['assigned']},
            { DisplayName: 'Hoogste bod', RequestFilter: ['assignedNotConfirmed']}],

            // API fields
            DefaultOrdering: 'DESC', // This can be set to ASC and DESC and will affect the view's ordering.
            DefaultFilter: { DisplayName: 'Te verwachten', RequestFilter: ['assignedNotDelivered'] },
            DefaultSearchField: { DisplayName: 'Taxatienummer', RequestFilter: 'id' },
            ApiFields: ["id", "VehicleSpecification-Vehicle-make", "VehicleSpecification-Vehicle-modelSpecific",
            "BidList", "VehicleSpecification-Vehicle-registration", "VehicleSpecification-Vehicle-year",
            "VehicleSpecification-BodyType", "VehicleSpecification-FuelType", "VehicleSpecification-mileage",
            "dateDelivery", "soldDate", "soldPrice", "assignedDate",
            "assignedPrice", "VehicleSpecification-type", "ExpertViews", "VehicleSpecification-mileageType"]
        });
    }
}
